import { APP_ID, NgModule, TransferState } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule, provideClientHydration, withNoHttpTransferCache } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';

import jss from 'jss';
import preset from 'jss-preset-default';

import { browserTranslationsModuleConfig, BrowserTranslationProvider } from '@web-builder/core/configs/translations.config';
import { JwtInterceptor } from '@web-builder/core/interceptors/jwt.interceptor';
import { CustomTransferState } from '@common/services/custom-transfer-state';
import { AppComponent } from './app.component';
import { AppStoreModule } from '@web-builder/store/app-store.module';
import { RESOURCE_URL } from '@sites/analytics/tokens';
import { TransferStateService } from '@web-builder/core/services/transfer-state.service';
import { CommonModule } from '@angular/common';
import { BlockWrapperComponent } from '@web-builder/components/block-wrapper/block-wrapper.component';
import { ColumnWrapperComponent } from '@web-builder/components/column-wrapper/column-wrapper.component';
import { ModalsComponent } from '@web-builder/components/modals/modals.component';
import { SpecificBlockWrapperComponent } from '@web-builder/components/specific-block-wrapper/specific-block-wrapper.component';
import { SpecificColumnWrapperComponent } from '@web-builder/components/specific-column-wrapper/specific-column-wrapper.component';
import { SpecificSectionWrapperComponent } from '@web-builder/components/specific-section-wrapper/specific-section-wrapper.component';
import { StructureWrapperComponent } from '@web-builder/components/structure-wrapper/structure-wrapper.component';
import { WidgetResolverComponent } from '@web-builder/core/resolvers/widget-resolver.component';
import ShopCartIconComponent from '@web-builder/widgets/shop-cart-icon/shop-cart-icon.component';

jss.setup(preset());

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        TranslateModule.forRoot(browserTranslationsModuleConfig),
        ModalModule.forRoot(),
        AppStoreModule,
        CommonModule,
        WidgetResolverComponent,
        BlockWrapperComponent,
        SpecificBlockWrapperComponent,
        SpecificSectionWrapperComponent,
        ColumnWrapperComponent,
        SpecificColumnWrapperComponent,
        StructureWrapperComponent,
        TranslateModule,
        ModalsComponent,
        ShopCartIconComponent,
    ],
    providers: [
        BrowserTranslationProvider,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true,
        },
        {
            provide: RESOURCE_URL,
            useFactory: (transferStateService: TransferStateService) => transferStateService.getResourceUrl(),
            deps: [TransferStateService],
        },
        { provide: APP_ID, useValue: 'webBuilderApp' },
        { provide: TransferState, useClass: CustomTransferState },
        provideClientHydration(withNoHttpTransferCache()),
        provideHttpClient(withFetch(), withInterceptorsFromDi()),
        provideAnimations(),
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
